import { useContext } from "react";
import { ModalContext } from "context/modals";
import { SelectedItems } from "context/selected_items";
import ModalLayout from "layout/Modal";
import { useForm, SubmitHandler } from "react-hook-form";
import { useMutation } from "react-query";
import { handleErrors, fetcher } from "services/apiClient";
import { ButtonLoader } from "components/Loading";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Input, SelectInput, TextArea } from "components/Input/InputFields";

interface IFormInput {
  amount: string;
  bank_id: string;
  naration: string;
}

const WithdrawFromAccount = () => {
  const history = useNavigate();
  const { withdrawalModal, setWithdrawalModal } = useContext(ModalContext);
  const { merchantBankAccount, setBankResolutionDetails, merchantID } =
    useContext(SelectedItems);

  const { isLoading, mutateAsync } = useMutation(
    (formData) => fetcher("merchant-v1/withdrawal/run", formData),
    { retry: false }
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormInput>();

  const addAccount: SubmitHandler<IFormInput> = async (data: any) => {
    const merchant_id = merchantID;
    // console.log({ merchant_id, ...data });
    try {
      const res = await mutateAsync({ merchant_id, ...data });
      toast.success(res.message);
      setBankResolutionDetails(res.data);
      setWithdrawalModal(!withdrawalModal);
    } catch (error) {
      handleErrors(error, history);
    }
  };

  return (
    <ModalLayout setIsOpen={setWithdrawalModal} isOpen={withdrawalModal}>
      <h4 className="mid20 modal_header">Make Withdrawal</h4>
      <form className="width100" onSubmit={handleSubmit(addAccount)}>
        <SelectInput
          name="id"
          // options={allBanks}
          register={register}
          label="Select an Account"
        >
          <option value="">Select an Account</option>
          {merchantBankAccount?.map((value: any, index: number) => (
            <option key={index} value={value.id}>
              {value.account_name} {value.account_number} {value.bank_name}
            </option>
          ))}
        </SelectInput>

        {errors.amount && (
          <span className="reg12 form_error">
            Please check the amount entered
          </span>
        )}
        <Input
          label=""
          placeholder="Enter amount to withdraw"
          type="text"
          {...register("amount", {
            required: "Please provide a value",
          })}
        />

        <span>Fee: NGN 25</span>

        {errors.naration && (
          <span className="reg12 form_error">
            Please check business desctiption
          </span>
        )}
        <TextArea
          label=""
          placeholder="Please enter a reason for withdrawal"
          isModal={true}
          {...register("naration", {
            required: "Please provide a value",
          })}
        />

        <div className="width100">
          <button className="modal_btn modal_btn_main" type="submit">
            {!isLoading ? "Withdraw Amount" : <ButtonLoader />}
          </button>
        </div>
      </form>
    </ModalLayout>
  );
};

export default WithdrawFromAccount;
